<nz-spin [nzSpinning]="isIframeLoading" [nzTip]="'Loading...'">
  <iframe name="iframe3CE" id="iframe3CE" class="iframe-full" frameBorder="0" allowtransparency="true" [src]="iFrameLink | safe" (load)="iframeLoadingEvent($event)"></iframe>
</nz-spin>